export default "__VITE_ASSET__CGjugq$h__"